<template>
  <v-content>
    <!-- New design home as full page banners -->
    <!-- TODO move fluid container to each page -->
    <template v-if="$route.name === 'home' || $route.name === 'search' || $route.name === 'newsletter' || $route.name === 'about'" class="main-container pb-4 mb-3">
      <router-view :key="routerKey" />
    </template>
    <v-container v-else fluid mx-auto px-4 pb-4 pt-2 mb-3 class="main-container">
      <router-view :key="routerKey" />
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      routerKey: 1
    };
  },

  watch: {
    /**
     * Experimental feature!!!
     * We want to use geolocation to set the language of the app.
     * Which is done by `fetchUserLocale()` method in App.vue.
     * The locale might be changed after the app has mounted so
     * we need to reload all the components and the best and easy
     * way to do that is updating the key in router file
     */
    "$i18n.locale": function() {
      this.routerKey++;
    }
  }
};
</script>
